

module.exports = __webpack_require__.stylable.create(
    "o1",
    {"classes":{"root":"s323","label":"s324","select":"s325"},"vars":{"base-font-family":"--o0-base-font-family"},"stVars":{},"keyframes":{}},
    "",
    2,
    14,
    null
);
